type dataDescryption = {
  jobRequirements: string[]
  jobDescription: string[]
  benefits: string[]
  aboutSenspark: string
  whyJoin: string[]
}

type ListLocation = {
  title: string
  date: string
  area: string
  time: string
  level: string
  position: string
  salary: string
  id: string
  data: dataDescryption
}

export const list: ListLocation[] = [
  {
    title: 'GAME DEVELOPER (JUNIOR, MID)',
    area: 'Ho Chi Minh City, Vietnam',
    date: '01/01/2023',
    position: 'Fulltime',
    level: 'Junior, Mid',
    time: 'Full time',
    id: '1',
    salary: '$500-1000',
    data: {
      jobRequirements: ["At least 2 years of experience making games using Unity.",
        "Good at C#, OOP, data structures, and algorithms.",
        "Excellent troubleshooting & problem-solving skills.",
        "Understanding of several multiplayer technologies.",
        "Game performance optimization (resource loading, quality render ...).",
        "Have experience in developing large-scale systems with high coin currency.",
      ],
      jobDescription: [
        "Implement game features & core functions using Unity or C++ (depending on each assigned project).",
        "Build the game and its supporting application stacks.",
        "Organize and manage technical features, work with supervisors in making detailed plans and timelines that work towards the fulfillment of project objectives.",
        "Maintain and implement modules from external sources.",
        "Working with team members (PM / Unity Developers/Back-end Developers/3D designers) to complete the best project.",
        "Learn and implement new technologies to the project.",
      ],
      benefits: [
        "Attractive salary based on ability.",
        "Year-end bonus according to business activities (in 2021: Bonus up to nearly 8 months' salary).",
        "Lunch stipend: 50,000 VND/day.",
        "Social insurance is paid 100% by the company.",
        "15 days of annual leave, refund of remaining unused leave.",
        "Free parking at the building.",
        "Monthly parties, team building activities, annual travel, and many other interesting events to boost connection and engagement among employees.",
        "Many entertainment areas to relieve stress: PS5 game machine, Foodball tables.",
        "Willing to facilitate, discover the potential to enhance the value of each employee.",
      ],
      aboutSenspark: "Senspark was proud to be an indie game developer with 12 years of experience in game development and application, operation and management. Up to date, Senspark has recorded the total number of more than 100 million downloads from games globally. Some of the most outstanding products of Senspark include: Stickman, Bombsquad, Tank, Gold Miner, Tiến Lên Miền Nam, Block Craft, Galaxy Shooter… Senspark has developed the top #1 NFT game on BNB Chain called Bomb Crypto, with a community of more than 1.2M users.",
      whyJoin: [
        "Ready to become the best version of yourself: Senspark will help unleash and maximize your potential.",
        "Career development opportunities: We regularly review staff performance to properly consider promoting to Sub-Lead, Lead, etc.",
        "Dynamic growth: New projects regularly with an increase in scope and scale, joining Senspark now is a great decision.",
        "A work culture of openness, friendliness, sociability, willingness to support, and camaraderie of Senspark employees.",
      ],
    }

  },
  {
    title: 'DIGITAL MARKETING SPECIALIST',
    area: 'Ho Chi Minh City, Vietnam',
    date: '01/01/2023',
    position: 'Fulltime',
    level: 'Junior, Mid',
    time: 'Full time',
    id: '2',
    salary: 'upto $1000',
    data: {
      jobRequirements: ["At least 2 years of experience.",
        "Good thinking, experience in optimizing Google/Facebook Ads channels.",
        "Basic understanding of such tools as: Google Analytics, Google search console, Appsflyers, etc.",
        "Having knowledge about the NFT (blockchain) Game market, grasping the trend well for advertising ideas.",
        "Smart, agile, hardworking, responsible, eager to learn and study data.",
        "Good English communication skills.",
      ],
      jobDescription: [
        "Building, managing and optimizing Ad campaigns on social media platforms (Google Adwords, Facebook, Tiktok, Snapchat,...) for the Global market blockchain Game.",
        "Analyzing and evaluating ads metrics, optimize ads, and bring high quality users.",
        "Planning User Acquisition (UA) development strategy (target audience, QC network, budget, ...)",
        "Able to write advertising content, announcement content in English.",
        "Coming up with creative ideas to order banners, clips for Team design/videos",
        "Actively working with advertising supply partners.",
        "Creating performance reports and proposing options to improve advertising.",
        "Building, measuring, optimizing and periodically reporting on important indicators of the website as well as digital marketing activities.",
        "Other duties assigned by supervisor or manager.",
      ],
      benefits: [
        "Attractive salary based on ability.",
        "Bonus according to the company's revenue and your contribution: 13th month salary bonus, holiday bonus, Lunar New Year's lucky money, etc.",
        "Review salary every 6 months.",
        "Lunch Allowance: 50,000 per working day.",
        "Working time: 40 hours/week, Monday - Friday, 8:30am - 6:00pm",
        "Working in a dynamic, creative, professional environment with many opportunities for personal development.",
        "Full benefits according to national regulations: social insurance, health insurance, unemployment insurance (the company pays 100%, not deducted from the agreed salary).",
        "15 days of annual leave, refund of remaining unused leave.",
        "Participate in fun and entertainment activities in the company: Pendulum, PS 4 game console, weekly soccer...",
        "Monthly parties, team building activities, annual travel, picnic, and many other interesting events to boost connection and engagement among employees.",
      ],
      aboutSenspark: "Senspark was proud to be an indie game developer with 12 years of experience in game development and application, operation and management. Up to date, Senspark has recorded the total number of more than 100 million downloads from games globally. Some of the most outstanding products of Senspark include: Stickman, Bombsquad, Tank, Gold Miner, Tiến Lên Miền Nam, Block Craft, Galaxy Shooter… Senspark has developed the top #1 NFT game on BNB Chain called Bomb Crypto, with a community of more than 1.2M users.",
      whyJoin: [
        "Ready to become the best version of yourself: Senspark will help unleash and maximize your potential.",
        "Career development opportunities: We regularly review staff performance to properly consider promoting to Sub-Lead, Lead, etc.",
        "Dynamic growth: New projects regularly with an increase in scope and scale, joining Senspark now is a great decision.",
        "A work culture of openness, friendliness, sociability, willingness to support, and camaraderie of Senspark employees.",
      ],
    }

  }
]

type Benefit = {
  title: string
  description: string
}

export const benefits: Benefit[] = [
  {
    title: 'Dynamic Growth',
    description: 'We move fast with new projects regularly.',
  },
  {
    title: 'Personal Development',
    description: 'We help you unleash and maximize your potential',
  },
  {
    title: 'Entertainment',
    description: `Having fun at work is a key element of people's happiness`,
  },
  {
    title: 'Attractive Salary',
    description:
      'We make sure our team members can focus on the bigger picture.',
  },
]
